import "antd/dist/antd.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import Auth from "layouts/Auth";
import { Provider } from "react-redux";
import "./index.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import store from "store";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Admin from "layouts/Admin";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/admin" render={(props) => <Admin {...props} />} />
        <Route path="/auth" render={(props) => <Auth {...props} />} />
        <Redirect from="*" to="/auth/login" />
      </Switch>
    </BrowserRouter>
  </Provider>
);
